import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border-bottom"
}
const _hoisted_2 = {
  key: 2,
  class: "border-bottom"
}

import {computed} from 'vue';
import ProductDetails from "@/views/OrdersComponents/OrderDetails/ProductDetails/ProductDetails.vue";
import ServicePackageDetails
  from "@/views/OrdersComponents/OrderDetails/ServicePackageDetails/ServicePackageDetails.vue";
import InstalmentsDetails from "@/views/OrdersComponents/OrderDetails/ServicePackageDetails/InstalmentsDetails.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCardItemDetails',
  props: {
  item: {
    type: Object,
    required: true
  },
  paymentStatus: {
    type: Object,
    default: () => ({color: '', status: ''})
  },
  supplierOrder: {
    type: Object,
    default: () => ({})
  },
  order: {
    type: Object,
    default: () => ({})
  },
  supplierId: {
    type: String,
  }
},
  setup(__props) {

const props = __props;

const isClinicServiceOrPackage = computed(() => {
  return props.item.type === 'clinic_service' || props.item.type === 'service' || isPackage.value;
});

const isShipping = computed(() => {
  return props.item.type === 'shipping_method';
});

const isPackage = computed(() => {
  return props.item.type === 'clinic_package' || props.item.type === 'package'
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      (isClinicServiceOrPackage.value)
        ? (_openBlock(), _createBlock(ServicePackageDetails, {
            key: 0,
            "is-clinic-service-or-package": isClinicServiceOrPackage.value,
            "is-shipping": isShipping.value,
            item: __props.item,
            order: __props.order,
            "payment-status": __props.paymentStatus,
            "supplier-id": __props.supplierId,
            "supplier-order": __props.supplierOrder
          }, null, 8, ["is-clinic-service-or-package", "is-shipping", "item", "order", "payment-status", "supplier-id", "supplier-order"]))
        : (_openBlock(), _createBlock(ProductDetails, {
            key: 1,
            "is-shipping": isShipping.value,
            item: __props.item,
            "payment-status": __props.paymentStatus,
            "supplier-id": __props.supplierId
          }, null, 8, ["is-shipping", "item", "payment-status", "supplier-id"]))
    ]),
    (__props.order.instalments.length > 0 && isPackage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1))
      : _createCommentVNode("", true),
    (__props.order.instalments.length > 0 && isPackage.value)
      ? (_openBlock(), _createBlock(InstalmentsDetails, {
          key: 1,
          order: __props.order,
          supplierOrder: __props.supplierOrder
        }, null, 8, ["order", "supplierOrder"]))
      : _createCommentVNode("", true),
    (!isShipping.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})